module.exports = __webpack_public_path__ + "static/media/welcome-4.44555602.jpg";